import { z } from 'zod';

import { productListSearchParams, productListSearchSchema } from '@/features/resource-pickers';

import type { StoreProductListParams } from '../api/store-catalog-api';
import {
  STORE_PRODUCT_EXTRA_FIELDS,
  STORE_PRODUCT_SORTS,
} from '../components/store-product-filters';

/**
 * URL search params of the store catalog list; mirrors GET /admin/v1/stores/{storeId}/products
 * with the store-scope product filters the picker shares (D-182). The params it took before
 * (status, publishedAt, productId, scheduleState, scheduleId) keep their names. Lazy: the
 * feature doors import each other in a ring, so the schema is built on first use.
 */
export const storeProductListSearchSchema = z.lazy(() =>
  productListSearchSchema('store', {
    sort: STORE_PRODUCT_SORTS,
    extraFields: STORE_PRODUCT_EXTRA_FIELDS,
  }),
);

export type StoreProductListSearch = z.infer<typeof storeProductListSearchSchema>;

/** The list request for a validated search, `includeTotal` on the first page. */
export function storeProductListParams(search: StoreProductListSearch): StoreProductListParams {
  return productListSearchParams(search, 'store', STORE_PRODUCT_EXTRA_FIELDS);
}
